import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage, deleteToken, Messaging } from "firebase/messaging";

export const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

const app = initializeApp(firebaseConfig);
const messaging: Messaging = getMessaging(app);

const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY || "";


export const requestPermission = async (fromUserGesture = false): Promise<string | undefined> => {
    try {
        if (!("Notification" in window)) {
            console.warn("This browser does not support desktop notifications.");
            return undefined;
        }

        let permission = Notification.permission;

        // Hanya request permission jika belum diputuskan DAN dipicu oleh aksi user (user gesture)
        if (permission === "default" && fromUserGesture) {
            try {
                permission = await Notification.requestPermission();
            } catch (err) {
                console.warn("Could not request notification permission:", err);
                return undefined;
            }
        }

        if (permission === "granted") {
            console.log("Notification permission is granted.");

            let serviceWorkerRegistration: ServiceWorkerRegistration | undefined;
            if ("serviceWorker" in navigator) {
                try {
                    serviceWorkerRegistration = await navigator.serviceWorker.register(
                        "/firebase-messaging-sw.js",
                        { scope: "/" }
                    );
                    await navigator.serviceWorker.ready;
                    console.log(
                        "Service Worker ready:",
                        serviceWorkerRegistration
                    );
                } catch (swErr) {
                    console.error("Failed to register Firebase Service Worker:", swErr);
                }
            }

            const tokenOptions: { vapidKey?: string; serviceWorkerRegistration?: ServiceWorkerRegistration } = {};
            if (VAPID_KEY) {
                tokenOptions.vapidKey = VAPID_KEY;
            }
            if (serviceWorkerRegistration) {
                tokenOptions.serviceWorkerRegistration = serviceWorkerRegistration;
            }

            const token = await getToken(messaging, tokenOptions);

            console.log("FCM Token:", token);
            return token;
        } else if (permission === "denied") {
            console.warn("Notification permission is denied in browser settings.");
        }
    } catch (error) {
        console.error("Error getting notification permission / token:", error);
    }
};

export const subscribeToForegroundMessages = (
    callback: (payload: any) => void
) => {
    return onMessage(messaging, (payload) => {
        callback(payload);
    });
};

export const onMessageListener = (): Promise<any> =>
    new Promise((resolve) => {
        onMessage(messaging, (payload) => {
            resolve(payload);
        });
    });

export const onServiceWorkerMessageListener = (
    callback: (data: any) => void
) => {
    if ("serviceWorker" in navigator) {
        const handler = (event: MessageEvent) => {
            if (
                event.data?.type === "FCM_BACKGROUND_NOTIFICATION" ||
                event.data?.type === "NOTIFICATION_CLICKED"
            ) {
                callback(event.data);
            }
        };
        navigator.serviceWorker.addEventListener("message", handler);
        return () => navigator.serviceWorker.removeEventListener("message", handler);
    }
    return () => { };
};

export const deleteFcmToken = async (): Promise<boolean> => {
    try {
        if (!messaging) return false;
        return await deleteToken(messaging);
    } catch (err) {
        console.warn("Could not delete FCM token locally:", err);
        return false;
    }
};
